<div class="lang-switcher" [ngClass]="open ? 'open' : ''">
  <nav class="langs">
    <button class="margin-r-1" *ngFor="let lang of languages" [ngClass]="{'active': language === lang}"
            (click)="changeLanguage(lang)">
      {{ lang | i18nextCap }}
    </button>
  </nav>
</div>
